import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Card, Typography } from 'antd';
import { useErrorLogger } from '../../../utils';
import { useSelector } from 'react-redux';
import { getOptionsByPath } from '../../../utilsdata';
import NewQuoteInformation from './NewQuoteInformation';
import ExistingPolicyInformation from './ExistingPolicyInformation';
import { InputField, CheckboxField, SelectInput, TextareaField } from '../../../blueplanitUtils/InputField';
import { REQUEST_DETAILS, REQUEST_TYPE, REQUEST_DEPARTMENT, PERSONAL_LINE } from '../../../Dropdownmanager';

const RequestForm = (props) => {
  const { RequestInfo, handleChange, values, errors, touched, handleBlur, setFieldValue } = props;
  let employeeDetails = props.employeeDetails;
  let setEmployeeDetails = props.setEmployeeDetails;
  let initialValues = props.initialValues;

  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const { logError } = useErrorLogger();

  const [insuredName, setInsuredName] = useState(values.insuredName);
  const [comments, setComments] = useState(values.comments);

  const getNoofDisplayName = () => {
    try {
      if (values?.processType === 'EOP Template') return "No. of Templates";
      else if (values?.processType === 'Endorsements') return "No. of Endorsements";
      else if (values?.processType === 'Audits') return "No. of Audits";
      else if (values?.processType === 'Pre-Renewal Letters') return "No. of Letters";
      else if (values?.processType === 'Cancellations') return "No. of Notices";
      else if (values?.processType === 'Certificate Issuance') return "No. of Certificates";
      else if (values?.processType === 'Auto ID Cards') return "No. of Auto ID’s";
      else if (values?.processType === 'Policy Checking') return "No. of Policies";
      else return "Number of Quotes";
    } catch (error) {
      logError("RequestForm", "get quotename based on process type", error.message);
    }
  };

  useEffect(() => setInsuredName(values.insuredName), [values.insuredName]);
  useEffect(() => setComments(values.comments), [values.comments]);

  return (
    <Card title="Request Details">
      <Form layout="vertical" component={false}>

        {/* === TOP TWO COLUMN LAYOUT === */}
        <div className="request-main-box">
          <div className="request-two-col">

            {/* ===== LEFT COLUMN ===== */}
            <div className="request-left-col" style={{ marginTop: '10px' }}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <Form.Item
                    validateStatus={touched?.quoteType && errors.quoteType ? 'error' : ''}
                    help={touched.quoteType && errors.quoteType ? errors.quoteType : null}
                  >
                    <div className="field-row" style={{ marginBottom: '-20px', marginLeft: '-20px' }}>
                      <div className="field-label" style={{ marginTop: '-20px', marginLeft: '60px' }}>Request Type</div>
                      <SelectInput
                        name="quoteType"
                        value={values?.quoteType || RequestInfo?.quoteType || undefined}
                        onChange={(value) => handleChange({ target: { name: 'quoteType', value } })}
                        placeholder="Select Request Type"
                        options={getOptionsByPath(NestedDatabucket, [REQUEST_DETAILS, REQUEST_TYPE])}
                      />
                    </div>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    validateStatus={touched.insuredName && errors.insuredName ? 'error' : ''}
                    help={touched.insuredName && errors.insuredName ? errors.insuredName : null}
                  >
                    <div className="field-row" style={{ marginTop: '-15px', marginLeft: '-20px' }}>
                      <div className="field-label" style={{ marginLeft: '60px' }}>Insured Name</div>
                      <InputField
                        id="insuredName"
                        name="insuredName"
                        placeholder="Enter Insured Name"
                        value={insuredName}
                        onChange={(e) => setInsuredName(e.target.value)}
                        onBlur={(e) => handleChange(e)}
                      />
                    </div>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    validateStatus={touched.noofQuotes && errors.noofQuotes ? 'error' : ''}
                    help={touched.noofQuotes && errors.noofQuotes ? errors.noofQuotes : null}
                  >
                    <div className="field-row" style={{ marginTop: '-30px', marginLeft: '-20px' }}>
                      <div className="field-label" style={{ marginLeft: '40px' }}>{getNoofDisplayName(values)}</div>
                      <InputField
                        name="noofQuotes"
                        type="text"
                        placeholder="Enter value"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={values.noofQuotes}
                        onChange={(e) => {
                          const re = /^\d*$/;
                          if (re.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </div>

            {/* ===== RIGHT COLUMN ===== */}
            <div className="request-right-col" style={{ marginTop: '10px' }}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <div className={`right-two-col-grid ${values?.department === 'Personal Line' ? 'personal-line' : ''}`}>

                    <div className="field-block" style={{ marginBottom: '-20px' }}>
                      <div className="field-label" style={{ marginTop: '-20px' }}>Department</div>
                      <SelectInput
                        name="department"
                        value={values?.department || RequestInfo?.department || undefined}
                        onChange={(value) => handleChange({ target: { name: 'department', value } })}
                        placeholder="Select Department"
                        options={getOptionsByPath(NestedDatabucket, [REQUEST_DETAILS, REQUEST_DEPARTMENT])}
                      />
                    </div>

                    {values?.department === 'Personal Line' && (
                      <div className="field-block" style={{ marginBottom: '-20px' }}>
                        <div className="field-label" style={{ marginTop: '-20px' }}>Quote Type</div>
                        <SelectInput
                          name="personalQuoteType"
                          mode="multiple"
                          value={values.personalQuoteType || []}
                          placeholder="Select Quote Type"
                          onChange={(value) =>
                            handleChange({ target: { name: 'personalQuoteType', value } })
                          }
                          options={getOptionsByPath(NestedDatabucket, [
                            REQUEST_DETAILS,
                            REQUEST_DEPARTMENT,
                            PERSONAL_LINE
                          ])?.map(o => ({
                            value: o.value || o.name,
                            label: o.label || o.name
                          }))}
                        />

                      </div>
                    )}

                    {values?.processType === 'Certificate Issurance' &&
                      values?.department === 'Commercial Lines' &&
                      [
                        { label: 'Holder Name', name: 'holderName' },
                        { label: 'Insured Delivery', name: 'insuredDelivery' },
                        { label: 'Holder Delivery', name: 'holderDelivery' },
                        { label: 'Account Manager Delivery', name: 'accountManagerDelivery' },
                        { label: 'Other Delivery', name: 'otherDelivery' }
                      ].map((f) => (
                        <div className="field-block" key={f.name}>
                          <div className="field-label">{f.label}</div>
                          <InputField
                            style={{ marginTop: '-5px' }}
                            name={f.name}
                            value={values[f.name] || ''}
                            onChange={handleChange}
                            placeholder={`Enter ${f.label}`}
                          />
                        </div>
                      ))
                    }

                  </div>
                </Col>
              </Row>
            </div>

          </div>
        </div>
      </Form>

      {/* === EXISTING POLICY + NEW QUOTE (unchanged) === */}
      {(values?.department === 'Personal Line') && (
        <Row gutter={16} align="stretch" style={{ marginTop: 24 }}>
          <Col span={12}>
            <div style={{ border: "1px solid #D9D9D9", background: "#ffffff", padding: "12px 16px", borderRadius: 2, width: "100%", flex: 1 }}>
              <ExistingPolicyInformation
                initialValues={initialValues}
                employeeDetails={employeeDetails}
                setEmployeeDetails={setEmployeeDetails}
                handleChange={handleChange}
                values={values}
                RequestInfo={RequestInfo}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
              />
            </div>
          </Col>

          <Col span={12}>
            <div style={{ border: "1px solid #D9D9D9", background: "#ffffff", padding: "12px 16px", borderRadius: 2, width: "100%" }}>
              <NewQuoteInformation
                initialValues={initialValues}
                employeeDetails={employeeDetails}
                setEmployeeDetails={setEmployeeDetails}
                handleChange={handleChange}
                values={values}
                RequestInfo={RequestInfo}
                errors={errors}
                touched={touched}
              />
            </div>
          </Col>
        </Row>
      )}

      {(values?.processType === 'Policy Quoting' && values?.department === 'Commercial Lines') && (
        <>
          <ExistingPolicyInformation
            initialValues={initialValues}
            employeeDetails={employeeDetails}
            setEmployeeDetails={setEmployeeDetails}
            handleChange={handleChange}
            values={values}
            RequestInfo={RequestInfo}
          />
          <NewQuoteInformation
            initialValues={initialValues}
            employeeDetails={employeeDetails}
            setEmployeeDetails={setEmployeeDetails}
            handleChange={handleChange}
            values={values}
            RequestInfo={RequestInfo}
          />
        </>
      )}

      {/* === COMMENTS (unchanged) === */}
      <Col span={24} style={{ marginTop: 20 }}>
        <Typography.Title level={5}>Comments</Typography.Title>
        <Form.Item>
          <TextareaField
            rows={4}
            name="comments"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            onBlur={(e) => handleChange(e)}
            placeholder="Enter Comments"
          />
        </Form.Item>
      </Col>
    </Card>
  );
};

export default RequestForm;
